var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#1B203D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8251 4.05248C10.7726 4.01749 10.7026 4 10.6327 4C10.6327 4 10.6327 4 10.6152 4H5.36735C5.17493 4 5 4.15743 5 4.36735V10.9621C5 11.1545 5.15743 11.3294 5.36735 11.3294H6.41691V12.6064C6.41691 12.7289 6.46939 12.8338 6.57434 12.9038C6.62682 12.9388 6.69679 12.9563 6.76676 12.9563C6.81924 12.9563 6.87172 12.9388 6.90671 12.9213L10.7726 11.277C10.9125 11.2245 11 11.0845 11 10.9446V4.36735C10.9825 4.2449 10.93 4.12245 10.8251 4.05248ZM5.73469 10.5773V4.7172H8.86589L6.64431 5.6793C6.50437 5.73178 6.41691 5.87172 6.41691 6.01166V10.5773H5.73469ZM10.2653 10.7172L7.1516 12.0466V6.23907L10.2653 4.90962V10.7172ZM8.3586 8.84548C8.3586 9.0484 8.19417 9.21283 7.99125 9.21283C7.78834 9.21283 7.62391 9.0484 7.62391 8.84548C7.62391 8.64257 7.78834 8.47813 7.99125 8.47813C8.19417 8.47813 8.3586 8.64257 8.3586 8.84548Z",
    fill: "#1B203D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHall);
export default __webpack_public_path__ + "static/media/icon-hall.47f5f140b7c1a1b6692b33f88b8fc2ab.svg";
export { ForwardRef as ReactComponent };